import { render, staticRenderFns } from "./editParametro.vue?vue&type=template&id=4d0ead34&scoped=true"
import script from "./editParametro.vue?vue&type=script&lang=js"
export * from "./editParametro.vue?vue&type=script&lang=js"
import style0 from "./editParametro.vue?vue&type=style&index=0&id=4d0ead34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ead34",
  null
  
)

export default component.exports